import api from "./api";

export const getAllWorkAreas = async () => {
  const res = await api.get("/BookingDetails/GetWorkAreaDetails");
  const data = res?.data;
  let list = [];
  if (Array.isArray(data)) list = data;
  else if (Array.isArray(data?.resultSet)) list = data.resultSet;

  // normalize to { id, code, name, status }
  return list.map((w) => {
    return {
      id: w.WAID || w.Id || w.id || w.workAreaId || 0,
      code: w.WAcode || w.code || w.workAreaCode || "",
      name: w.WAname || w.name || w.workAreaName || "",
      lat:
        w.lat ||
        w.Lat ||
        w.latitude ||
        w.Latitude ||
        w.WALatitude ||
        w.workAreaLatitude ||
        "",
      lon:
        w.lon ||
        w.Lon ||
        w.lng ||
        w.Lng ||
        w.longitude ||
        w.Longitude ||
        w.WALongitude ||
        w.workAreaLongitude ||
        "",
      status: w.status || w.Status || "A",
      raw: w,
    };
  });
};

export const postWorkArea = async (workArea) => {
  const payload = [
    {
      WAcode: workArea.code,
      WAname: workArea.name,
      status: workArea.status || "A",
      lat: workArea.lat,
      lon: workArea.lon,
    },
  ];
  const res = await api.post("/BookingRegister/PostWorkAreaDetails", payload, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export default {
  getAllWorkAreas,
  postWorkArea,
};
